import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

type Props = {
  count?: number;
} & SVGIconProps;

export const CommentIcon = ({ count, style }: Props) => {
  return (
    <Center style={style}>
      <svg
        width="27"
        height="21"
        viewBox="0 0 27 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9178 0.775391C14.5808 0.775391 15.2167 1.03878 15.6855 1.50762C16.1544 1.97646 16.4178 2.61235 16.4178 3.27539V9.94206C16.4178 10.6051 16.1544 11.241 15.6855 11.7098C15.2167 12.1787 14.5808 12.4421 13.9178 12.4421H5.22835L1.4375 15.2246L1.39502 12.4421C1.39502 12.4421 1.41776 11.2302 1.41776 9.94206V3.27539C1.41776 2.61235 1.68115 1.97646 2.14999 1.50762C2.61884 1.03878 3.25472 0.775391 3.91776 0.775391H13.9178Z"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {count ? (
          <>
            <circle cx="19" cy="12.2246" r="7.5" fill="white" stroke="white" />
            <text
              x="68%"
              y="63%"
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="10"
              fontWeight="bold"
              fill="#333"
            >
              {count}
            </text>
          </>
        ) : (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            x="35%"
            y="25%"
          >
            <circle cx="6.57568" cy="6.55664" r="6.5" fill="white" />
            <g transform="translate(0.5,0.5)">
              <path
                d="M3.07568 6.05664H9.07568"
                stroke="#676979"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.07568 3.05664V9.05664"
                stroke="#676979"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        )}
      </svg>
    </Center>
  );
};
